module.exports = __webpack_public_path__ + "954dad8130368ecfc32e0a765a472434.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main-bg.jpg
// module id = 147
// module chunks = 0